import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=54ca1034&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=54ca1034&prod&lang=scss&scoped=true"
import style1 from "./Catalog.vue?vue&type=style&index=1&id=54ca1034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca1034",
  null
  
)

export default component.exports